import { Link } from "react-router-dom";
import { brandLogoWide } from "../../../../utils";

const HeaderLayout2 = ({ admissionImg }) => {
  return (
    <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-3 gap-md-5">
      <div className="text-center text-md-start">
        <Link to="/" className="logo-link">
          <img
            src={brandLogoWide()}
            alt="Logo"
            className="img-fluid"
            style={{
              width: "100%",
              maxWidth: admissionImg > 0 ? admissionImg + "px" : "100%",
            }}
          />
        </Link>
      </div>

      <div className="d-flex border-top border-bottom border-start border-end">
        <Link to="/sign-in" className="header-tile">
          <i className="fa-solid fa-lock"></i>
          <span>SIGN IN</span>
        </Link>

        <Link to="/sign-up" className="header-tile bg-main-theme text-white">
          <i className="fa-solid fa-user-plus text-white"></i>
          <span className="text-white">REGISTER</span>
        </Link>
      </div>
    </div>
  );
};

export default HeaderLayout2;
